import { assert } from '@logosdx/utils';
export var QueueState = /*#__PURE__*/ function(QueueState) {
    QueueState["running"] = "running";
    QueueState["paused"] = "paused";
    QueueState["stopped"] = "stopped";
    QueueState["draining"] = "draining";
    return QueueState;
}({});
export class QueueStateManager {
    status = "stopped";
    #allowedTransitions = {
        ["running"]: [
            "paused",
            "draining",
            "stopped"
        ],
        ["draining"]: [
            "stopped",
            "paused"
        ],
        ["paused"]: [
            "running",
            "draining",
            "stopped"
        ],
        ["stopped"]: [
            "running",
            "draining"
        ]
    };
    transition(to) {
        assert(this.#allowedTransitions[this.status].includes(to), `Invalid transition from ${this.status} to ${to}`);
        this.status = to;
    }
    is(...states) {
        return states.includes(this.status);
    }
    get state() {
        return this.status;
    }
}
